import { type ForwardedRef, forwardRef } from 'react';
import { Box } from './Box';
import {
  AlignItems,
  Display,
  FlexDirection,
  FlexDirectionShortcuts,
  Grid as GridType,
  JustifyContent,
  ResponsiveProperties,
  PolymorphicProps,
  CssProps,
  FluidProperties,
  Paddings,
  Margins,
  Gaps,
} from './types';

type Props = PolymorphicProps<
  ResponsiveProperties<
    Omit<
      CssProps,
      keyof (Display &
        GridType &
        FlexDirection &
        FlexDirectionShortcuts &
        AlignItems &
        JustifyContent &
        Paddings &
        Margins &
        Gaps)
    >
  > &
    (
      | ({ inline?: boolean } & ResponsiveProperties<{ display?: never }>)
      | ({ inline?: never } & ResponsiveProperties<{ display?: 'none' | 'contents' | 'grid' | 'inline-grid' }>)
    ) &
    (FluidProperties<Paddings> | ResponsiveProperties<Paddings>) &
    (FluidProperties<Margins> | ResponsiveProperties<Margins>) &
    (FluidProperties<Gaps> | ResponsiveProperties<Gaps>)
>;

export const Grid = forwardRef(function _Grid({ inline, display, ...rest }: Props, ref: ForwardedRef<HTMLDivElement>) {
  return <Box display={inline ? 'inline-grid' : (display ?? 'grid')} ref={ref} {...rest} />;
});
